import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { generalService } from '../../services/general.service';
import { Material } from '../../models/materiales';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';

@Component({
  selector: 'my-materials-consult-delete',
  templateUrl: './materiales-consult-delete.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class MaterialesConsultDeleteComponent implements OnInit {

  public title = 'Materiales';
  public getInactives = false;
  public disabledCheck = true;

  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'ITEM_CONVERT_ID', 'NAME_BUY', 'NAME_SELL', 'QUANTITY'];
  public productList: Array<Material>;
  public numberOfRecords = 0;

  private loacs;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));

  // Modal messages
  private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea eliminar el material?';
  private readonly DELETE_SUCCESS_MSG = 'Material eliminado exitosamente';
  //private readonly REACTIVATE_SUCCESS_MSG = 'Producto reactivado exitosamente';

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private _generalService: generalService,
              public dataService: DataService,
              public dialog: MatDialog,
              private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.loacs = sessionStorage.getItem("acslo");
    this.consultGrid();
  }

  confirmDeleteProduct(itemID) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;

    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;

    dialogModal.afterClosed()
               .subscribe(result => {
                 if (this.dataService.guardado) {
                  this.deleteProduct(itemID);
                 }
               });
  }

  deleteProduct(itemID: number) {
    this._generalService.metodoCallParams(itemID, 'material/deleteConversionMaterial/')
        .subscribe(ok => {
          this._generalService.toastCall(this.DELETE_SUCCESS_MSG);
          this.consultGrid();
        }, error => {
          // Custom error handler
        });
  }

  // consultProducts() {
  //   this.consult();
  // }

  // consultDisabledItems() {
  //   this.consult(true);
  // }

  // consult(disabledProducts=false) {
  //   this._generalService.metodoCallParams(this.loacs, `item/${disabledProducts? 'consultDisabledItems' : 'consultItems'}`)
  //       .finally(() => this.disabledCheck = false)
  //       .subscribe(products => {
  //         this.productList = JSON.parse(products);
  //         this.numberOfRecords = this.productList.length;

  //         if (this.productList.length > 0) {
  //           this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
  //         } else {
  //           this.dataSource = undefined;
  //         }

  //       }, error => {
  //         // Custom error handler
  //       });
  // }

  consultGrid() {
    var itemID = undefined;
    this._generalService.metodoCallParams(itemID, 'material/consultaMaterials/')
        .subscribe(products => {
          this.productList = JSON.parse(products);
          this.numberOfRecords = this.productList.length;

          if (this.productList.length > 0) {
            this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
          } else {
            this.dataSource = undefined;
          }

        }, error => {
          // Custom error handler
        });
  }

  // checkChange() {
  //   this.disabledCheck = true;
  //   this.cdr.detectChanges();
  //   if (this.getInactives) {
  //     this.consultDisabledItems();
  //   } else {
  //     this.consultProducts();
  //   }
  // }

  // reactivateProduct(material: Material) {
  //   this._generalService.metodoCallParams(this.loacs, `item/enable?itemId=${material.itemID}`)
  //   .subscribe(ok => {
  //     this._generalService.toastCall(this.REACTIVATE_SUCCESS_MSG);
  //     this.productList = this.productList.filter(item => item.itemID !== material.itemID);
      
  //     if (this.productList.length > 0) {
  //       this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
  //     } else {
  //       this.dataSource = undefined;
  //     }

  //   }, error => {
  //     // Custom error handler
  //   });
  // }

  searchFilter(searchTerm: string) {
      if(this.productList.length <= 0) {
        this.dataSource = undefined;
      } else {
        let filteredProducts = this.productList;
        if(searchTerm != "") {
          filteredProducts = this.productList.slice().filter((material: Material) => {            
            if (material.itemID.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                material.ITEM_ID_COMPRA.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                material.ITEM_ID_VENTA.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                material.contenedorAVentaConfig.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) != -1)
                return true;
            else
                return false;
          });
        }
        this.dataSource = new DataSourceGrid(filteredProducts, this.paginator, this.sort);
        this.numberOfRecords = filteredProducts.length;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/materiales/consult-delete/materiales-consult-delete.component.ts